import React from "react";

const Addressdata = ({ datalist }) => {

  console.log("fffff",datalist)

  return (
    <div className="w-full">
      <div>
        <span className="text-textcolor2 text-base title1 font-semibold">Delivery Address</span>
      </div>
      <div className="flex justify-between items-start bg-Background1 rounded-xl px-6 py-4 mt-2">
        <p className="title1 text-textColor text-sm">
          {datalist?.delivery_address?.house_number} {datalist?.delivery_address?.house_number}
        </p>
      </div>
      <div className="mt-6">
        <span className="text-textcolor2 text-base title1 font-semibold">Order Summery</span>
      </div>
      <div className="flex flex-col justify-between items-start bg-Background1 rounded-t-xl px-6 py-3 mt-2">
        <div className="flex justify-between items-center w-full ">
          <span className=" title1 text-[#5D6D56] text-sm">Product Prize</span>
          <span className="title2 text-sm"> ₹ {datalist?.mrp_price}</span>
        </div>
        <div className="flex justify-between items-center w-full ">
          <span className="title1 text-[#5D6D56] text-sm">Discount 15%</span>
          <span className="title2 text-sm">- ₹ {datalist?.discount_on_mrp}</span>
        </div>
       
        <div className="flex justify-between items-center w-full ">
          <span className="title1 text-[#5D6D56] text-sm">Packaging Charges</span>
          <span className="title2 text-sm">₹ {datalist?.packaging_charge}</span>
        </div>
        <div className="flex justify-between items-center w-full ">
          <span className="title1 text-[#5D6D56] text-sm">Tax</span>
          <span className="title2 text-sm">₹ {datalist?.tax}</span>
        </div>
      </div>
      <div className="bg-[#DCE5D6] text-textColor font-bold rounded-b-xl">
        <div className="flex justify-between items-center w-full px-6 py-4">
          <span className="title1 text-[#5D6D56]">Total</span>
          <span className="title2 text-[#5D6D56]" >₹ {datalist?.total}</span>
        </div>
      </div>
    </div>
  );
};

export default Addressdata;
